module.exports = require('swiper/swiper-bundle.js');
